import { toast } from 'react-toastify'

import api from '../../../lib/api'

export const AUDIT_FETCHING = 'AUDIT_FETCHING'
export const AUDIT_DONE = 'AUDIT_DONE'
export const AUDIT_FAILED = 'AUDIT_FAILED'

export const START_AUDIT_FETCHING = 'START_AUDIT_FETCHING'
export const START_AUDIT_DONE = 'START_AUDIT_DONE'
export const START_AUDIT_FAILED = 'START_AUDIT_FAILED'

export const AUDIT_MODAL_REGIONS_FETCHING = 'AUDIT_MODAL_REGIONS_FETCHING'
export const AUDIT_MODAL_REGIONS_DONE = 'AUDIT_MODAL_REGIONS_DONE'
export const AUDIT_MODAL_REGIONS_FAILED = 'AUDIT_MODAL_REGIONS_FAILED'

export const AUDIT_MODAL_RULES_FETCHING = 'AUDIT_MODAL_RULES_FETCHING'
export const AUDIT_MODAL_RULES_DONE = 'AUDIT_MODAL_RULES_DONE'
export const AUDIT_MODAL_RULES_FAILED = 'AUDIT_MODAL_RULES_FAILED'

export const AUDIT_MODAL_PARTNERS_FETCHING = 'AUDIT_MODAL_PARTNERS_FETCHING'
export const AUDIT_MODAL_PARTNERS_DONE = 'AUDIT_MODAL_PARTNERS_DONE'
export const AUDIT_MODAL_PARTNERS_FAILED = 'AUDIT_MODAL_PARTNERS_FAILED'

export const AUDIT_MODAL_RULESETS_FETCHING = 'AUDIT_MODAL_RULESETS_FETCHING'
export const AUDIT_MODAL_RULESETS_DONE = 'AUDIT_MODAL_RULESETS_DONE'
export const AUDIT_MODAL_RULESETS_FAILED = 'AUDIT_MODAL_RULESETS_FAILED'

export const RULESET_CREATION_SENDING = 'RULESET_CREATION_SENDING'
export const RULESET_CREATION_SUCCESS = 'RULESET_CREATION_SUCCESS'
export const RULESET_CREATION_FAILED = 'RULESET_CREATION_FAILED'
export const RULESET_CREATION_RESET = 'RULESET_CREATION_RESET'

export const AUDIT_FILE_SENDING = 'AUDIT_FILE_SENDING'
export const AUDIT_FILE_SUCCESS = 'AUDIT_FILE_SUCCESS'
export const AUDIT_FILE_FAILED = 'AUDIT_FILE_FAILED'
export const AUDIT_FILE_RESET = 'AUDIT_FILE_RESET'

export const AUDIT_AMENDMENT_MODAL_RULES_FETCHING =
  'AUDIT_AMENDMENT_MODAL_RULES_FETCHING'
export const AUDIT_AMENDMENT_MODAL_RULES_DONE =
  'AUDIT_AMENDMENT_MODAL_RULES_DONE'
export const AUDIT_AMENDMENT_MODAL_RULES_FAILED =
  'AUDIT_AMENDMENT_MODAL_RULES_FAILED'

export const AUDIT_RULE_AMENDMENT_SENDING = 'AUDIT_RULE_AMENDMENT_SENDING'
export const AUDIT_RULE_AMENDMENT_SUCCESS = 'AUDIT_RULE_AMENDMENT_SUCCESS'
export const AUDIT_RULE_AMENDMENT_FAILED = 'AUDIT_RULE_AMENDMENT_FAILED'
export const AUDIT_RULE_AMENDMENT_RESET = 'AUDIT_RULE_AMENDMENT_RESET'

const requestAuditList = () => ({
  type: AUDIT_FETCHING,
})

const receiveAuditList = (auditList, pageTotal, page) => ({
  type: AUDIT_DONE,
  auditList,
  pageTotal,
  page,
})

const startAudit = () => ({
  type: START_AUDIT_FETCHING,
})
const startAuditDone = () => ({
  type: START_AUDIT_DONE,
})
const startAuditFailed = message => ({
  type: START_AUDIT_FAILED,
  message,
})
const fetchFailed = message => ({
  type: AUDIT_FAILED,
  message,
})

const fetchingAuditModalRegionsData = () => ({
  type: AUDIT_MODAL_REGIONS_FETCHING,
})
const receivedAuditModalRegionsData = regionList => ({
  type: AUDIT_MODAL_REGIONS_DONE,
  regionList,
})
const failedAuditModalRegionsData = message => ({
  type: AUDIT_MODAL_REGIONS_FAILED,
  message,
})

const fetchingAuditModalRulesData = () => ({
  type: AUDIT_MODAL_RULES_FETCHING,
})
const receivedAuditModalRulesData = ruleList => ({
  type: AUDIT_MODAL_RULES_DONE,
  ruleList,
})
const failedAuditModalRulesData = message => ({
  type: AUDIT_MODAL_RULES_FAILED,
  message,
})

const fetchingAuditModalPartnersData = () => ({
  type: AUDIT_MODAL_PARTNERS_FETCHING,
})
const receivedAuditModalPartnersData = partnerList => ({
  type: AUDIT_MODAL_PARTNERS_DONE,
  partnerList,
})
const failedAuditModalPartnersData = message => ({
  type: AUDIT_MODAL_PARTNERS_FAILED,
  message,
})

const fetchingAuditModalRulesetsData = () => ({
  type: AUDIT_MODAL_RULESETS_FETCHING,
})
const receivedAuditModalRulesetsData = rulesetList => ({
  type: AUDIT_MODAL_RULESETS_DONE,
  rulesetList,
})
const failedAuditModalRulesetsData = message => ({
  type: AUDIT_MODAL_RULESETS_FAILED,
  message,
})

const sendingRulesetCreationRequest = () => ({
  type: RULESET_CREATION_SENDING,
})
const successfulRulesetCreationResponse = response => ({
  type: RULESET_CREATION_SUCCESS,
  response,
})
const failedRulesetCreationResponse = response => ({
  type: RULESET_CREATION_FAILED,
  response,
})
export const resetRulesetCreationState = () => ({
  type: RULESET_CREATION_RESET,
})
const auditFileSending = () => ({
  type: AUDIT_FILE_SENDING,
})
const auditFileFailed = () => ({
  type: AUDIT_FILE_FAILED,
})
const auditFileSuccess = () => ({
  type: AUDIT_FILE_SUCCESS,
})
export const auditFileReset = () => ({
  type: AUDIT_FILE_RESET,
})

const fetchingAuditAmendmentModalRulesData = () => ({
  type: AUDIT_AMENDMENT_MODAL_RULES_FETCHING,
})
const receivedAuditAmendmentModalRulesData = ruleList => ({
  type: AUDIT_AMENDMENT_MODAL_RULES_DONE,
  ruleList,
})
const failedAuditAmendmentModalRulesData = message => ({
  type: AUDIT_AMENDMENT_MODAL_RULES_FAILED,
  message,
})

const sendingAuditRuleAmendmentRequest = () => ({
  type: AUDIT_RULE_AMENDMENT_SENDING,
})
const successfulAuditRuleAmendmentResponse = () => ({
  type: AUDIT_RULE_AMENDMENT_SUCCESS,
})
const failedAuditRuleAmendmentResponse = response => ({
  type: AUDIT_RULE_AMENDMENT_FAILED,
  response,
})
export const resetAuditRuleAmendmentState = () => ({
  type: AUDIT_RULE_AMENDMENT_RESET,
})

export const constructServiceBusMessage = (
  label,
  regionISOCode,
  fieldDelimiter,
  rulesetId,
  rules,
  partners,
  feedFilePath,
  companyName,
  brandName,
  collectProductFailureDetails
) => {
  // if there's a ruleset selected, no need to send rules over as well
  rules = rulesetId ? null : rules
  // if there's no ruleset make sure it's set to null
  rulesetId = rulesetId ? rulesetId : null

  const request = {
    Label: label,
    Timestamp: new Date().toISOString(),
    RequestorProduct: 0,
    RegionISOCode: regionISOCode,
    FieldDelimiter: fieldDelimiter,
    RulesetId: rulesetId,
    Rules: rules,
    Partners: partners,
    ExternalAuditId: null,
    FeedFilePath: feedFilePath,
    CompanyName: companyName,
    BrandName: brandName,
    CollectProductFailureDetails: collectProductFailureDetails,
  }
  return request
}

export function startNewAudit(
  t,
  auditRequest,
  selectedOrganisationId,
  organisationId,
  internalAuditFlag,
  dispatch,
  page,
  searchValue,
  sorting,
  filterQuery,
  companyName,
  label
) {
  dispatch(startAudit())

  let searchParams = new URLSearchParams({
    internalAuditFlag: internalAuditFlag,
  })

  if (selectedOrganisationId != null && organisationId != null) {
    searchParams.append('orgId', selectedOrganisationId)
  }

  api
    .post(`/feedaudit?${searchParams}`, auditRequest, {
      headers: { 'Content-Type': 'text/json' },
    })
    .then(() => {
      toast.success(t('feed_audit_request_sent'))
      dispatch(
        startAuditDone(
          fetchAuditList(
            false,
            organisationId,
            dispatch,
            page,
            t,
            searchValue,
            sorting,
            filterQuery,
            companyName,
            label
          )
        )
      )
    })
    .catch(error => {
      toast.error(t('feed_audit_creation_unsuccessful'))
      dispatch(startAuditFailed())
      return error
    })
}

export const saveNewRulesetToDatabase = (
  dispatch,
  newRulesetName,
  selectedRulesList,
  t
) => {
  dispatch(sendingRulesetCreationRequest())

  const rulesetCreationRequest = {
    name: newRulesetName,
    ruleIds: selectedRulesList,
  }

  api
    .post(`/feedaudit/rulesets`, rulesetCreationRequest)
    .then(response => {
      if (!response.data.success) {
        dispatch(failedRulesetCreationResponse(response.data.errorMessage))
      } else {
        dispatch(successfulRulesetCreationResponse(response.data))
        toast.success(t('ruleset_creation_success'))
      }
    })
    .catch(errorResponse => {
      const errorMessage = t('ruleset_creation_error')
      dispatch(failedRulesetCreationResponse(errorMessage))
    })
}

export const getRegionDataForDialogUI = dispatch => {
  dispatch(fetchingAuditModalRegionsData())

  api
    .get(`/feedaudit/regions`)
    .then(({ data }) => {
      dispatch(
        receivedAuditModalRegionsData(
          data.map(item => ({
            name: item.name,
            id: item.isoCode,
          }))
        )
      )
    })
    .catch(err => {
      dispatch(failedAuditModalRegionsData())
      return err
    })
}

export const getRulesetsForDialogUI = dispatch => {
  dispatch(fetchingAuditModalRulesetsData())

  api
    .get(`/feedaudit/rulesets`)
    .then(({ data }) => {
      dispatch(
        receivedAuditModalRulesetsData(
          data.map(item => ({
            name: item.name,
            id: item.id,
            rules: item.rules,
          }))
        )
      )
    })
    .catch(err => {
      dispatch(failedAuditModalRulesetsData())
      return err
    })
}

export const getRulesForDialogUI = dispatch => {
  dispatch(fetchingAuditModalRulesData())

  api
    .get(`/feedaudit/groups`)
    .then(({ data }) => {
      dispatch(receivedAuditModalRulesData(data))
    })
    .catch(err => {
      dispatch(failedAuditModalRulesData())
      return err
    })
}

export const getPartnersForDialogUI = dispatch => {
  dispatch(fetchingAuditModalPartnersData())

  api
    .get(`/feedaudit/partners`)
    .then(({ data }) => {
      dispatch(receivedAuditModalPartnersData(data))
    })
    .catch(err => {
      dispatch(failedAuditModalPartnersData())
      return err
    })
}

export const uploadFeedAuditFile = (data, dispatch, t) => {
  dispatch(auditFileSending())

  toast.warn(t('file_uploading'))

  let fiveMinutesInMilliseconds = 300000

  api
    .post(`/feedaudit/file`, data, {
      params: { fileName: data.name },
      timeout: fiveMinutesInMilliseconds,
    })
    .then(() => {
      dispatch(auditFileSuccess())
    })
    .catch(() => {
      dispatch(auditFileFailed())
    })
}

export const fetchAuditList = (
  loading,
  organisationId,
  dispatch,
  page = 0,
  t,
  searchValue,
  sorting = { id: 'Label', desc: false },
  filterQuery = {
    fromDate: '',
    toDate: '',
    scoreFrom: 0,
    scoreTo: 100,
    successFilter: false,
    failFilter: false,
    progressFilter: false,
    recalculatingFilter: false,
    recalculationFailedFilter: false,
  },
  dummyCompanyName,
  dummyLabel
) => {
  loading && dispatch(requestAuditList())

  // 'dummy' row refers to the row displaying the 'pending' audit the user just requested, before it is present in the feed auditor database to display organically
  const dummyRow = [
    {
      companyName: dummyCompanyName,
      createdBy: '',
      id: '',
      label: dummyLabel,
      progressStatus: 5,
      timestamp: '',
    },
  ]

  let searchParams = new URLSearchParams({
    page: page + 1,
    limit: 10,
    searchValue: searchValue,
    sort: sorting.id,
    desc: sorting.desc,
    fromDate: filterQuery.fromDate,
    toDate: filterQuery.toDate,
    scoreFrom: filterQuery.scoreFrom,
    scoreTo: filterQuery.scoreTo,
    successFilter: filterQuery.successFilter,
    failFilter: filterQuery.failFilter,
    progressFilter: filterQuery.progressFilter,
    recalculatingFilter: filterQuery.recalculatingFilter,
    recalculationFailedFilter: filterQuery.recalculationFailedFilter,
  })

  if (organisationId != null) searchParams.append('orgId', organisationId)

  let keysForDel = []
  searchParams.forEach((value, key) => {
    if (value == '') {
      keysForDel.push(key)
    }
  })
  keysForDel.forEach(key => {
    searchParams.delete(key)
  })

  const auditUrl = `/feedaudit?${searchParams}`

  api
    .get(auditUrl)
    .then(({ data, headers: { fm_pagination_total } }) => {
      var msPerMinute = 60000
      var thirtyMinsAgo = new Date(Date.now() - 30 * msPerMinute)

      if (
        dummyLabel != null && // If dummy row is present
        page == null && // If on first page
        !data.some(
          audit =>
            audit.label == dummyLabel && // If there isn't an audit from the last 30 mins with same label
            new Date(audit.timestamp) < thirtyMinsAgo
        )
      ) {
        // add dummy row and remove last item (if needed) to keep page total consistent
        fm_pagination_total++
        data = dummyRow.concat(data)
        if (fm_pagination_total > 10) {
          data.pop()
        }
      }

      const pageTotal = Math.ceil(fm_pagination_total / 10)
      dispatch(receiveAuditList(data, pageTotal, page))
    })
    .catch(err => {
      dispatch(fetchFailed(err.message))
      toast.error(t('feed_audit_fetch_failed'))
    })
}

export const getRulesForAuditAmendmentDialogUI = (auditId, dispatch) => {
  dispatch(fetchingAuditAmendmentModalRulesData())

  api
    .get(`/feedaudit/${auditId}/groups`)
    .then(({ data }) => {
      dispatch(receivedAuditAmendmentModalRulesData(data))
    })
    .catch(err => {
      dispatch(failedAuditAmendmentModalRulesData())
      return err
    })
}

export const removeRulesFromAudit = (
  dispatch,
  auditId,
  selectedRulesList,
  t
) => {
  dispatch(sendingAuditRuleAmendmentRequest())

  const rulesetRemovalRequest = {
    auditId: auditId,
    rulesToRemove: selectedRulesList,
  }

  api
    .post(`/feedaudit/${auditId}/removeRules`, rulesetRemovalRequest)
    .then(() => {
      dispatch(successfulAuditRuleAmendmentResponse())
      toast.success(t('audit_rule_amendment_success'))
    })
    .catch(errorResponse => {
      const errorMessage = t('audit_rule_amendment_error')
      dispatch(failedAuditRuleAmendmentResponse(errorMessage))
      return errorResponse
    })
}
